import { useEffect } from 'react';
export function useModalFix({ state, popoverRef, targetRef, }) {
    useEffect(() => {
        // если селект в модалке, то клик по бекдропу модалки не приводит ни к чему
        // приходится костылить
        function clickOutside(e) {
            var _a, _b;
            if (e.target === popoverRef.current ||
                ((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)))
                return;
            if (e.target === targetRef.current || ((_b = targetRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target)))
                return;
            if (state.isOpen) {
                state.close();
            }
        }
        document.addEventListener('pointerdown', clickOutside, true);
        return () => {
            document.removeEventListener('pointerdown', clickOutside, true);
        };
    }, [state]);
}
